export var ArcGisGraveColumn;
(function (ArcGisGraveColumn) {
    ArcGisGraveColumn["GraveObjectID"] = "OBJECTID";
    ArcGisGraveColumn["Cemetery"] = "Cemetery";
    ArcGisGraveColumn["PlotNumber"] = "PlotNumber";
    ArcGisGraveColumn["Capacity"] = "Capacity";
    ArcGisGraveColumn["GraveStatus"] = "GraveStatus";
    ArcGisGraveColumn["GraveID"] = "GraveID";
    ArcGisGraveColumn["MarkerType"] = "MarkerType";
    ArcGisGraveColumn["CemeteryID"] = "CemeteryID";
})(ArcGisGraveColumn || (ArcGisGraveColumn = {}));
